export const FETCH_ORDERS_SUMMARY_SUCCESS = 'db/FETCH_ORDERS_SUMMARY_SUCCESS'
export const FETCH_MEAL_VOUCHER_TRANSACTIONS_SUCCESS =
  'db/FETCH_MEAL_VOUCHER_TRANSACTIONS_SUCCESS'
